import axios from 'axios';

// Use same backend as distributor APK so new registrations appear in admin. Set REACT_APP_API_URL for local backend.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://server.vgas.in/api';

/** Base URL for uploads (no /api). Use for resolving relative image URLs in admin. */
export const uploadsBaseUrl = API_BASE_URL.replace(/\/api\/?$/, '');

const apiService = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiService;

